// extracted by mini-css-extract-plugin
export default {"loaderContainer":"JRr8CJ"};